import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Table } from '../../../../components/Sessions/Table';
import { useLazyGetUpcomingSessionsQuery } from '../../../../../store/services/student/SessionService';
import Pagination from '../../../../components/Dashboard/Pagination';
import { CalendarModal } from '../../../../components/Sessions/CalendarModal'; // Import modal
import { addToCalendar } from '../../../../../utils/calendarUtils'; // Import calendar functions
import { getColumns } from '../../../../components/Dashboard/Columns';

export const StudentUpcomingSessions = ({showStudentName = false, showLanguage = true}) => {
  const navigate = useNavigate();
  const [sessionsData, setSessionsData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [pageSize] = useState(10);
  
  // Modal state
  const [showCalendarModal, setShowCalendarModal] = useState(false);
  const [selectedSession, setSelectedSession] = useState(null);

  const [triggerGetUpcomingSessions, { data, isLoading, error }] = useLazyGetUpcomingSessionsQuery();
  const fetchData = () => {
    triggerGetUpcomingSessions({ pageNumber: currentPage, pageSize, search: searchTerm });
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, searchTerm]);

  useEffect(() => {
    if (data?.data) {
      setSessionsData(data.data.items || []);
      setTotalCount(data.data.totalCount || 0);
    }
  }, [data]);

  // Handle opening calendar modal
  const handleOpenCalendarModal = (session) => {
    setSelectedSession(session);
    setShowCalendarModal(true);
  };

  // Handle adding to calendar
  const handleAddToCalendar = (calendarType) => {
    if (selectedSession) {
      addToCalendar(selectedSession, calendarType);
      setShowCalendarModal(false);
    }
  };

  // Close modal
  const handleCloseModal = () => {
    setShowCalendarModal(false);
    setSelectedSession(null);
  };

  if (isLoading) return <div className="text-center py-5"><div className="spinner-border" role="status"></div></div>;
  if (error) return <div className="alert alert-danger">Error loading upcoming sessions.</div>;

  return (
    <>
      <div className="bg-white">
        <div className="page-title flex-wrap mb-0">
          <div className="input-group search-area mb-md-0 ml-3">
            <input
              type="text"
              className="form-control ps-4"
              placeholder="Search upcoming sessions..."
              value={searchTerm}
              onChange={(e) => {
                setCurrentPage(1);
                setSearchTerm(e.target.value);
              }}
            />
          </div>
        </div>

        <Table
          data={sessionsData}
          columns={
            getColumns(sessionsData, showStudentName, showLanguage, true, true, handleOpenCalendarModal)
          }
          pageSize={pageSize}
          filterConfig={[]}
          buttonConfig={[]}
          searchableColumns={[]}
          onRowClick={(item) => navigate(`/sessions/sessionDetails/${item.sessionId}`)}
        />
 
      <Pagination currentPage={currentPage} totalCount={totalCount}
          pageSize={pageSize} onPageChange={setCurrentPage} />
    </div>

      {/* Calendar Modal */}
      {selectedSession && (
        <CalendarModal
          show={showCalendarModal}
          onHide={handleCloseModal}
          session={selectedSession}
          onAddToCalendar={handleAddToCalendar}
        />
      )}
    </>
  );
};